import React from 'react';
import { Grid, Typography } from '@mui/material';

const OfficineInfo = ({ tradeName, officeCIP, titulaire, group }) => {
  return (
    <Grid container rowSpacing={8}>
      <Grid item xs={6} sm={4}>
        <Typography component="h3" variant="h3_bold">
          Nom de l'officine
        </Typography>
        <Typography
          component="p"
          variant="h3_bold"
          color="primary"
          sx={{ marginTop: '1rem', width: '60%' }}
        >
          {tradeName}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography component="h3" variant="h3_bold">
          CIP Officine
        </Typography>
        <Typography
          component="p"
          variant="h3_bold"
          color="primary"
          sx={{ marginTop: '1rem' }}
        >
          {officeCIP}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography component="h3" variant="h3_bold">
          Titulaire
        </Typography>
        <Typography
          component="p"
          variant="h3_bold"
          color="primary"
          sx={{ marginTop: '1rem' }}
        >
          {titulaire}
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography component="h3" variant="h3_bold">
          Groupement
        </Typography>
        <Typography
          component="p"
          variant="h3_bold"
          color="primary"
          sx={{ marginTop: '1rem' }}
        >
          {group}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default OfficineInfo;
